import React, { useState } from "react";
import Input from "react-input-mask";
import LogoDefault from "../../../assets/images/semlogo.png";
import { Toast } from "../../../shared_components";
import whitelabel from "../../../services/whitelabel";

import {
  Container,
  Title,
  DivFile,
  Image,
  InputsDiv,
  ButtonSubmit,
  LabelFile,
  CheckDiv,
  Subtitles,
  DivForm,
} from "./styles";
import "bootstrap/dist/css/bootstrap.min.css";

function WhiteLabelForm() {
  const [imgData, setImgData] = useState(LogoDefault);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [nomeCurto, setNomeCurto] = useState("");
  const [url, setUrl] = useState("");
  const [logo, setLogo] = useState("");
  const [siteWL, setSiteWL] = useState("");
  const [estado, setEstado] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  function onImgLoad({ target: img }) {
    if (img.naturalWidth > 540 || img.naturalHeight > 90) {
      Toast(
        "Atenção",
        "Dimensões, altura e/ou largura, da imagem excedidas.",
        "danger",
        5000,
        "top",
        "top-right"
      );
      setImgData(LogoDefault);
      return;
    }

    setLogo(img.src);
  }

  const register = async (e) => {
    e.preventDefault();

    if (
      nome === "" ||
      email === "" ||
      telefone === "" ||
      cnpj === "" ||
      nomeCurto === "" ||
      url === "" ||
      siteWL === "" ||
      logo === LogoDefault ||
      estado === ""
    ) {
      Toast(
        "Atenção",
        "Por favor preencher todos os dados.",
        "danger",
        5000,
        "top",
        "top-right"
      );
      return;
    }

    if (url.match(/[^a-zA-Z0-9]+/g, "")) {
      Toast(
        "Atenção",
        "Por favor não inserir na URL caracteres especiais ou espaços em brancos.",
        "danger",
        5000,
        "top",
        "top-right"
      );
      return;
    }

    if (url[0].match(/\d|,/g)) {
      Toast(
        "Atenção",
        "A primeira caractere da URL deve ser uma letra.",
        "danger",
        5000,
        "top",
        "top-right"
      );
      return;
    }

    if (url.includes("pdv.mobi")) {
      Toast(
        "Atenção",
        "Não precisa digitar pdv.mobi na URL.",
        "danger",
        5000,
        "top",
        "top-right"
      );
      return;
    }
    setIsLoading(true);

    const data = {
      nome,
      email,
      telefone,
      cnpj,
      nome_curto: nomeCurto,
      url,
      logo,
      siteWL,
      type: "cadWL",
      q: "principal",
    };
    try {
      const reponse = await whitelabel.register(data);

      if (reponse.data.ret.status === "erro") {
        if (reponse.data.ret.detalhe[0])
          Toast(
            "Ocorreu um problema",
            `${reponse.data.ret.detalhe[0].msg}`,
            "danger",
            5000,
            "top",
            "top-right"
          );
        else
          Toast(
            "Ocorreu um problema",
            `${reponse.data.ret.detalhe.msg}`,
            "danger",
            5000,
            "top",
            "top-right"
          );

        setIsLoading(false);
        return;
      }

      setNome("");
      setEmail("");
      setNomeCurto("");
      setTelefone("");
      setCnpj("");
      setImgData(LogoDefault);
      setUrl("");
      Toast("", "Cadastrado com sucesso!", "success", 5000, "top", "top-right");

      try {
        const movideskData = {
          cnpj,
          businessName: "WL " + nomeCurto,
          corporateName: nome,
          url: url + ".pdv.mobi",
          state: estado,
        };

        await whitelabel.insertPersonOnMovidesk(movideskData);
      } catch (err) {
        console.log("Erro ao integrar com o Movidesk", err);
        Toast(
          "Atenção",
          "Houve um problema ao integrar com o Movidesk!",
          "danger",
          5000,
          "top",
          "top-right"
        );
      }

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      Toast(
        "Atenção",
        "Por favor tente novamente!",
        "danger",
        5000,
        "top",
        "top-right"
      );
    }
  };

  const onDeletePicture = (e) => {
    setImgData(LogoDefault);
  };
  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const size = Math.round(e.target.files[0].size / 1024);
      if (size > 500) {
        Toast(
          "Atenção",
          "Tamanho da imagem não aceita.",
          "danger",
          5000,
          "top",
          "top-right"
        );
        return;
      }

      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImgData(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  return (
    <>
      <Container>
        <Title>White Label</Title>
        <DivForm>
          <DivFile>
            <Image src={imgData} onLoad={onImgLoad} />
            <LabelFile>
              <input
                style={{ display: "none" }}
                type="file"
                onChange={onChangePicture}
                accept="image/png"
                required
              />
              <ion-icon size="small" name="pencil-outline"></ion-icon>
            </LabelFile>

            <LabelFile style={{ background: "red" }}>
              <ion-icon
                size="small"
                name="trash-outline"
                onClick={onDeletePicture}
              ></ion-icon>
            </LabelFile>
            <CheckDiv>
              <ion-icon
                name="checkmark-circle-outline"
                style={{ color: "green" }}
              ></ion-icon>
              <Subtitles>Altura 90px</Subtitles>
            </CheckDiv>
            <CheckDiv>
              <ion-icon
                name="checkmark-circle-outline"
                style={{ color: "green" }}
              ></ion-icon>
              <Subtitles>Largura 540px</Subtitles>
            </CheckDiv>
            <CheckDiv>
              <ion-icon
                name="checkmark-circle-outline"
                style={{ color: "green" }}
              ></ion-icon>
              <Subtitles>Tamanho Máximo 500kb</Subtitles>
            </CheckDiv>
            <CheckDiv>
              <ion-icon
                name="checkmark-circle-outline"
                style={{ color: "green" }}
              ></ion-icon>
              <Subtitles>Imagem PNG</Subtitles>
            </CheckDiv>
          </DivFile>

          <InputsDiv>
            <div className="form-group col-xs-9">
              <label>Nome Curto</label>
              <Input
                required
                type="text"
                className="form-control"
                onChange={(e) => setNomeCurto(e.target.value)}
                maxLength="30"
                value={nomeCurto}
              />
            </div>
            <div className="form-group col-xs-9">
              <label>Nome Contato</label>
              <Input
                required
                type="text"
                value={nome}
                className="form-control"
                onChange={(e) => setNome(e.target.value)}
                maxLength="75"
              />
            </div>
            <div className="form-group col-xs-9">
              <label>E-mail Contato</label>
              <Input
                required
                type="email"
                className="form-control"
                onChange={(e) => setEmail(e.target.value)}
                maxLength="80"
                value={email}
              />
            </div>
            <div className="form-group col-xs-9">
              <label>Telefone Contato</label>
              <Input
                required
                type="text"
                className="form-control"
                onChange={(e) => setTelefone(e.target.value)}
                mask="(99)99999-9999"
                value={telefone}
              />
            </div>
            <div className="form-group col-xs-9">
              <label>CNPJ</label>
              <Input
                required
                placeholder="XX.XXX.XXX/0001-XX"
                mask="99.999.999/9999-99"
                type="text"
                className="form-control col-xs-3"
                onChange={(e) => setCnpj(e.target.value)}
                value={cnpj}
              />
            </div>
            <div className="form-group col-xs-7">
              <label>URL</label>
              <div style={{ display: "flex" }}>
                <Input
                  type="text"
                  className="form-control"
                  id=""
                  value={url}
                  required
                  onChange={(e) => setUrl(e.target.value)}
                  maxLength="30"
                />
                <span
                  style={{
                    marginLeft: "5px",
                    fontWeight: "bold",
                    fontSize: "15px",
                    marginTop: "10px",
                  }}
                >
                  pdv.mobi
                </span>
              </div>
            </div>
            <div className="form-group col-xs-9">
              <label>SITE</label>
              <div style={{ display: "flex" }}>
                <Input
                  type="text"
                  className="form-control"
                  id=""
                  value={siteWL}
                  required
                  onChange={(e) => setSiteWL(e.target.value)}
                  maxLength="26"
                />
              </div>
            </div>
            <div className="form-group col-xs-9">
              <label>Estado</label>
              <select
                className="form-control"
                value={estado}
                required
                onChange={(e) => setEstado(e.target.value)}
              >
                <option value="">Selecione um estado</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </div>
            <ButtonSubmit
              disabled={isLoading}
              style={{ flex: "none", height: "50px", marginTop: "25px" }}
              type="button"
              className="btn btn-success"
              onClick={register}
            >
              {isLoading ? "Enviando..." : "Enviar"}
            </ButtonSubmit>
          </InputsDiv>
        </DivForm>
      </Container>
    </>
  );
}

export default WhiteLabelForm;
